import React, { useEffect, useState } from "react";
import Logo from "../assets/svgs/logo.svg";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// import { Toaster } from "react-hot-toast";

const InviteLayout = () => {
  const { invitedUserDetails } = useSelector((store) => store.user);

  return (
    <div className={`auth`}>
      <div className="auth__aside invite__aside">
        <div className="auth__aside--content">
          <div className="brand">
            <img src={Logo} alt="Flance Logo" />
          </div>
          <div className="auth__aside--body">
            <div>
              <h1 className="font-semibold text-[40px] leading-[150%] text-white">
                Welcome.
              </h1>
              <p className="font-semibold text-[32px] leading-[150%] text-white">
                You've been invited by 
                <span className="text-[#B8E1FF]">
                  {invitedUserDetails?.data?.resellerName}
                </span>
              </p>
              <p className="font-medium text-[18px] leading-[150%] text-white">
                Please{" "}
                {invitedUserDetails?.data?.newProvider ? "sign up" : "login"} to
                confirm your business details and accept invite
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="auth__form">
        <Outlet />
      </div>
    </div>
  );
};

export default InviteLayout;
